export const DO_NOT_EXPORT = 'do_not_export';
export const AWAITING_DECISION = 'awaiting_decision';
export const NOT_SUBMITTED = 'not_submitted';
export const DEFAULT_VALUE = 'default_value';
